import React, {useEffect} from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Calculating from "./pages/Calculating";
import Results from "./pages/Results";
import Modal1 from './survey/Modal1'
import Modal2 from './survey/Modal2'
import Modal3 from './survey/Modal3'
import Modal4 from './survey/Modal4'
import Modal5 from './survey/Modal5'
import Modal6 from './survey/Modal6'
import Modal7 from './survey/Modal7'
import Modal8 from './survey/Modal8'


const MainRouter = () => {
  return (
    <Router>
      <Route exact path="/" component={() => 
      (
      <section id="survey">
          <Modal1 />
        </section>) } />
      <Route path="/survey/" >
        <section id="survey">
        <Route exact path="/survey/1" component={() => <Modal2 />} />
        <Route exact path="/survey/2" component={() => <Modal3 />} />
        <Route exact path="/survey/3" component={() => <Modal4 />} />
        <Route exact path="/survey/4" component={() => <Modal5 />} />
        <Route exact path="/survey/5" component={() => <Modal6 />} />
        <Route exact path="/survey/6" component={() => <Modal7 />} />
        <Route exact path="/survey/7" component={() => <Modal8 />} />
        </section>
        </Route>
      <Route exact path="/calculating" component={Calculating} />
      <Route exact path="/results" component={Results} />
    </Router>
  );
};

export default MainRouter;
